<script>
import { Bar } from 'vue-chartjs';
import { toCurrency, commaSeparated } from '@/utils/etc.js';
import { apiSalesReturnReceipt } from '@/api/report/report';
import { objectToFormData } from '@/api/util';
// import { apiGetSellerRank } from '@/api/statistics/statistics.js';
export default {
	extends: Bar,
	props: {
		from_date: String,
		to_date: String,
	},
	async mounted() {
		// let { data } = await apiGetSellerRank(this.from_date, this.to_date);
		const paramObj = {
			from_date: this.from_date,
			to_date: this.to_date,
			sales_group_code: null,
			state: '',
		};
		const param = objectToFormData(paramObj);
		const response = await apiSalesReturnReceipt(param);

		let data = response.data.value && Array.isArray(response.data.value.list) ? response.data.value.list : [];
		let sum_total_sale = response.data.value ? response.data.value.net_sales_amount : null;
		let average_sale_data = [];

		for (let i = 0; i < data.length; i++) {
			average_sale_data.push(sum_total_sale / data.length);

			for (let j = i + 1; j < data.length; j++) {
				if (data[i].net_sales_amount < data[j].net_sales_amount) {
					let temp = data.splice(i, 1, data[j]);
					data.splice(j, 1, temp[0]);
				}
			}
		}

		let total_sale_data = data.map(el => el.net_sales_amount);
		let labels = data.map(el => el.sales_group_name);
		let background_color_data = this.$colorListForChart;

		if (background_color_data.length < data.length) {
			for (let i = 0; i < data.length - background_color_data.length; i++) {
				let r = Math.floor(Math.random() * 255);
				let g = Math.floor(Math.random() * 255);
				let b = Math.floor(Math.random() * 255);

				background_color_data.push('rgba(' + r + ',' + g + ',' + b + ',0.8)');
			}
		}

		this.renderChart(
			{
				labels,
				datasets: [
					{
						type: 'line',
						label: 'Average Amount',
						borderColor: '#75FF00',
						fill: false,
						pointRadius: 0,
						pointHoverRadius: 0,
						data: average_sale_data,
					},
					{
						type: 'bar',
						label: 'Amount By Sales Group',
						backgroundColor: background_color_data,
						data: total_sale_data,
					},
				],
			},
			{
				animation: {
					duration: 1,
					onComplete: function() {
						let chartInstance = this.chart;
						let ctx = chartInstance.ctx;
						ctx.textAlign = 'center';
						ctx.fillStyle = 'rgba(0, 0, 0, 1)';
						ctx.textBaseline = 'bottom';

						let metaData = chartInstance.controller.getDatasetMeta(0).data;
						let lastIndex = metaData.length - 1;
						let dataset = this.data.datasets[0];
						var data = dataset.data[lastIndex];
						if (metaData[lastIndex]) ctx.fillText(`Average: ${toCurrency(data)}`, metaData[lastIndex]._model.x - 55, metaData[lastIndex]._model.y - 5);

						/*
						// Amount By Sales Group 만 그래프 위에 값 표시
						let meta = chartInstance.controller.getDatasetMeta(1);
						let dataset = this.data.datasets[1];
						meta.data.forEach(function(bar, index) {
							var data = dataset.data[index];
							ctx.fillText(data, bar._model.x, bar._model.y - 5);
						}); */

						/*
						// Loop through each data in the datasets
						this.data.datasets.forEach(function(dataset, i) {
							var meta = chartInstance.controller.getDatasetMeta(i);
							meta.data.forEach(function(bar, index) {
								var data = dataset.data[index];
								ctx.fillText(data, bar._model.x, bar._model.y - 5);
							});
						}); */
					},
				},
				hover: {
					animationDuration: 1, // amination.duration과 일치
					mode: 'nearest',
					intersect: true,
				},
				tooltips: {
					mode: 'nearest',
					intersect: false,
					position: 'bottom',
					xAlign: 'center',
					yAlign: 'bottom',
					callbacks: {
						title: function(tooltipItemList, data) {
							// let title = null;
							// let datasetIndex = tooltipItemList[0].datasetIndex; // 0: Average Amount, 1: Amount By Sales Group
							// if (datasetIndex === 0) title = data['datasets'][0]['label'];
							// else title = data['labels'][tooltipItemList[0]['index']];

							return data['labels'][tooltipItemList[0]['index']];
						},
						label: function(tooltipItem, data) {
							// let datasetIndex = tooltipItem.datasetIndex; // 0: Average Amount, 1: Amount By Sales Group
							let label = data['datasets'][1]['data'][tooltipItem['index']];

							return toCurrency(label);
						},
					},
					backgroundColor: '#C4D5FF',
					titleFontSize: 12,
					titleFontColor: '#0066ff',
					bodyFontColor: '#000',
					bodyFontSize: 12,
					displayColors: false,
				},
				responsive: true,
				maintainAspectRatio: false,
				scales: {
					yAxes: [
						{
							ticks: {
								minRotation: 45,
								callback: value => commaSeparated(value),
							},
						},
					],
				},
				plugins: {
					datalabels: {
						display: false,
					},
				},
			},
		);

		this.$emit('emitSumData', { 'Total Sale': sum_total_sale });

		this.$nextTick(() => {
			this.$refs.canvas.style.height = '350px';
		});
	},
};
</script>
